const ORDER_STATES = {
    Pendiente: 3,
    Preparando: 4,
    DeliveryPickup: 5,
    DeliveryPickupdev: 9,
    Cancelados: 2,
};

export default ORDER_STATES;
